// export const Environment = {
//     finance:'http://localhost:4202',
//     financePro: 'http://localhost:4101',
//     financeApi: 'https://staging-finance-api.ertikaz-tech.com',
//     financeProApi: 'https://staging-inventory-api.ertikaz-tech.com',
//     ertikazApi: 'https://ertikaz-api.ertikaz-tech.com'
// }

export const Environment = {
    finance: 'https://leanfinance.ertikaz-tech.com',
    financePro: 'https://financePro.ertikaz-tech.com',
    financeApi: 'https://leanfinance-api.ertikaz-tech.com',
    financeProApi: 'https://financepro-api.ertikaz-tech.com',
    ertikazApi: 'https://ertikaz-api.ertikaz-tech.com'
}